import(/* webpackMode: "eager" */ "C:\\DC\\projects\\maximus\\components\\common\\globals\\NavigationMenuInner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\DC\\projects\\maximus\\components\\common\\InnerBanner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\DC\\projects\\maximus\\components\\details\\VersityList.jsx");
